import { useEffect, useState } from "react";

export const OrderIdHeader = ({ displayName, api }) => {
  const [selectedCount, setSelectedCount] = useState(0);

  useEffect(() => {
    if (api) {
      // Ensure api is available
      const updateSelectedCount = () => {
        // Safely check if selectedNodes is an array before accessing length
        const selectedNodes = api.getSelectedNodes ? api.getSelectedNodes() : [];
        setSelectedCount(selectedNodes?.length || 0); // Set to 0 if undefined
      };

      // Listen to selectionChanged and modelUpdated events
      api.addEventListener("selectionChanged", updateSelectedCount);
      api.addEventListener("modelUpdated", updateSelectedCount);

      // Initialize the selected count when component mounts
      updateSelectedCount();

      // Cleanup the event listener when the component is unmounted
      return () => {
        api.removeEventListener("selectionChanged", updateSelectedCount);
        api.removeEventListener("modelUpdated", updateSelectedCount);
      };
    }
  }, [api]); // Ensure the effect reruns when the api or shipmentsTab changes

  return (
    <div>
      <div>{displayName}</div>
      {selectedCount > 0 && <div style={{ fontSize: "12px", color: "gray" }}>Selected: {selectedCount}</div>}
    </div>
  );
};
